import {FormField, FormFieldType, SelectionOption} from 'lionheartland';
import {ENPaymentIntentStatus} from '../../enums';

export class PutPaymentIntentFormFields {

    public amount: FormField
    public status: FormField
    public invoice: FormField

    constructor() {

        this.amount = new FormField(
          'amount',
          'Amount',
          null,
          FormFieldType.text,
          false,
        )
        this.status = new FormField(
          'status',
          'Status',
          null,
          FormFieldType.enumeration,
          false,
        )
        this.status.enumeration = ENPaymentIntentStatus
        this.invoice = new FormField(
          'invoice',
          'Invoice',
          'invoice',
          FormFieldType.pushedSelectionList,
          false,
        )

    }
}

const fields = new PutPaymentIntentFormFields()

export const putPaymentIntentFormFieldOptions: {[key: string]: FormField} = {
  amount: fields.amount,
  status: fields.status,
  invoice: fields.invoice,
};